<script setup lang="ts">
    import { ref } from 'vue';
    import TextInput from '../TextInput.vue';
    import { __ } from '@/js/stores/expressions';
    import EchoButton from '../EchoButton.vue';
    import LoadingDots from '../LoadingDots.vue';

    interface Props {
        error?: boolean;
        loading: boolean;
    }

    const props = withDefaults(defineProps<Props>(), { error: false });

    const emit = defineEmits<{
        (e: 'submit', value: string): void;
    }>();

    const password = ref<string>('');
</script>
<template>
    <div class="fixed top-0 left-0 w-full h-full flex justify-center items-center">
        <div class="bg-white rounded-lg shadow-md p-8 w-9/10 sm:w-120 h-60">
            <form
                v-if="!loading"
                class="flex flex-col gap-4 h-full justify-between"
                @submit.prevent="emit('submit', password)"
            >
                <p class="text-lg text-center">
                    {{ __('public-link-password-input-label') }}
                </p>
                <TextInput
                    v-model="password"
                    type="password"
                    :aria-required="true"
                    :aria-label="__('public-link-password-input-placeholder')"
                    :placeholder="__('public-link-password-input-placeholder')"
                    :aria-errormessage="__('public-link-password-input-error')"
                    class="w-full"
                />
                <p v-if="props.error" class="text-error px-4 text-sm">
                    {{ __('public-link-password-input-error') }}
                </p>
                <div class="flex justify-end">
                    <EchoButton type="submit">
                        {{ __('public-link-password-submit-button') }}
                    </EchoButton>
                </div>
            </form>
            <div v-else class="h-full w-full flex justify-center items-center">
                <LoadingDots />
            </div>
        </div>
    </div>
</template>
